module.exports = __webpack_public_path__ + "static/media/file-manager-icon.27c4bdc6.svg";